import { render, staticRenderFns } from "./auto-emails.vue?vue&type=template&id=5d550456&"
import script from "./auto-emails.vue?vue&type=script&lang=js&"
export * from "./auto-emails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports